import React from 'react';
import styled from 'styled-components';
import ReactSelect from 'react-select';


export const EventCategoryFiltertStyles = {
	DropdownContainer: styled.div`
		padding: 0;
		display:flex;
		width:100%;
		justify-content: flex-end;
	`,
	Dropdown: styled(ReactSelect)`
		width:100%;
		.react-select__control {
			border: 1px solid #eee;
			border-radius: 2px;
			width: 100%;
			&:hover {
				border: 1px solid #eee;

			}
			&:focus {
				border: 1px solid #eee;
			}
		}
	`,

};

const S = EventCategoryFiltertStyles;

const EventCategoryFilter = ({ events, dropdownEvents, updateEvents }) => {
	const options = dropdownEvents
		.map(event => ({ value: event.eventCategory.uuid, label: event.eventCategory.fullDescription }))
		.sort((a, b) => a.label.localeCompare(b.label))
		.filter((el, i, arr) => el.label !== (arr[i - 1] || {}).label);


	const groupedOptions = [
		{
			label: '',
			options: [{
				value: 'all',
				label: 'alle Kategorien',
			}],
		},
		{
			label: 'Kategorien',
			options,
		},
	];

	const handleSelection = (e) => {
		if (e.value === 'all') {
			updateEvents(events);
		} else {
			updateEvents(events.filter(event => event.eventCategory.uuid === e.value));
		}
	};

	return (
		<S.DropdownContainer>
			<S.Dropdown
				options={groupedOptions}
				onChange={handleSelection}
				placeholder="Kategorie auswählen"
				classNamePrefix="react-select"
			/>
		</S.DropdownContainer>
	);
};

export default EventCategoryFilter;
